import { fbt } from 'fbtee'
import { CalendarX } from 'lucide-react'

// Shown on EventPage when the promoter called the event off. We keep the page
// up rather than deleting it: anyone interested, or in a group linked to it,
// has it in their plans, and a silent disappearance leaves them guessing.
export function CancelledNotice({ reason }: { reason?: string }) {
  return (
    <div className="flex items-start gap-2.5 rounded-xl bg-destructive/10 ring-1 ring-destructive/30 px-3 py-2.5">
      <CalendarX className="size-4 shrink-0 mt-0.5 text-destructive" />
      <div className="min-w-0 space-y-0.5">
        <p className="text-sm font-medium text-destructive">
          {fbt('This event was cancelled', 'Heading of the banner on a cancelled event page')}
        </p>
        <p className="text-xs text-muted-foreground">
          {reason || (
            <fbt desc="Fallback body of the cancelled-event banner when we have no source detail">
              The organizer called it off. Check the ticket link for details.
            </fbt>
          )}
        </p>
      </div>
    </div>
  )
}
